/**
 * Pack Mule: a bigger backpack.
 *
 * The seed instance for a lever with no condition on it. Carry capacity is Strength's job, and this
 * multiplies the result rather than granting the stat, which is what makes the two stack without
 * either knowing about the other.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const PACK_MULE = {
  id: 'packMule',
  branch: 'scavenging',
  tier: 1,
  title: 'Pack Mule',
  blurb: 'Approved load-bearing posture. Consult a physician if the ringing does not stop.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [{ field: 'carryKg', perRank: 0.08, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
